import { render, staticRenderFns } from "./fileUpload.vue?vue&type=template&id=0d64d01c&scoped=true"
import script from "./fileUpload.vue?vue&type=script&lang=ts"
export * from "./fileUpload.vue?vue&type=script&lang=ts"
import style0 from "./fileUpload.vue?vue&type=style&index=0&id=0d64d01c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d64d01c",
  null
  
)

export default component.exports